import React, { memo } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

import Text from '../text/Text'

const EnhancedTableHead = ({ headers, ...restProps }) => {
  return (
    <TableHead>
      <TableRow>
        {headers.map((header, index) => (
          <TableCell
            key={index}
            align={header.numeric ? 'right' : 'left'}
            padding={header.disablePadding ? 'none' : 'normal'}
            {...restProps}
            sx={{
              backgroundColor: '#32363E', // @TODO: hard coded for now
              pl: '8px',
              pr: '8px',
              ...header.sx
            }}
          >
            {header.label && (
              <Text
                variant='subtitle1'
                fontSize={header.smallFont && '10px'}
                fontWeight={700}
                sx={{ lineHeight: 1.4 }}
                label={header.label}
              />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const TableHeaderBody = ({ size, headers, data, sx }) => {
  return (
    <Table
      stickyHeader
      aria-label='sticky table'
      sx={{ minWidth: 400, ...sx }}
      size={size}
    >
      <EnhancedTableHead headers={headers} />
      <TableBody>{data}</TableBody>
    </Table>
  )
}

export default memo(TableHeaderBody)
